import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-ingestion-status-popup',
  standalone: true,
 imports: [MatButtonModule, MatDialogActions, MatDialogClose, MatDialogContent, MatIcon],
  templateUrl: './ingestion-status-popup.component.html',
  styleUrl: './ingestion-status-popup.component.scss'
})
export class IngestionStatusPopupComponent {
 readonly dialogRef = inject(MatDialogRef<IngestionStatusPopupComponent>);
}
